<div class="quetion-panel-wrapper" [class.folded]="foldedSidebar">
  <div class="question-list">
    <qa-content-spinner [active]="isLoadingLeft">
      <div class="left flex-grow flex-align-items-start">
        <div
          class="questions-header"
          [class.hide-section]="wizardImports && !questions?.length"
          [class.time-limit-header]="!isLiveEvent && isScheduledExam"
        >
          <div class="questions-header-content">
            <div>
              @if(!isLiveEvent && isScheduledExam){
              <div class="time-limit-container">
                <span class="time-limit-label">{{
                  'exam.setup.timeToSolve' | translate
                }}</span>
                <qa-form-field-input
                  class="time-limit-input"
                  [type]="'number'"
                  [control]="scheduleForm.get('duration')"
                  (blurEvent)="onDurationValueChange($event)"
                >
                </qa-form-field-input>
                <span class="time-limit-unit">min</span>
              </div>
              }
              <div class="questions-header-text">
                {{ 'common.label.questions' | translate }}
              </div>
            </div>
            <div class="questions-header-actions">
              @if(wizardImports){
              <qa-button
                [isRaisedButton]="true"
                [isIconButton]="true"
                [isRoundedButton]="true"
                icon="add"
                data-cy="plusIcon"
                type="button"
                (submitted)="openAddContentDialog()"
              ></qa-button
              >} @else {
              <qa-button
                [matMenuTriggerFor]="questionmenu"
                #menuTrigger="matMenuTrigger"
                [isRaisedButton]="true"
                [isIconButton]="true"
                [isRoundedButton]="true"
                icon="add"
                type="button"
                data-cy="plusIcon"
              ></qa-button>
              <mat-menu #questionmenu="matMenu">
                <button
                  mat-menu-item
                  (click)="addQuestion()"
                  data-cy="addNormalQuestion"
                >
                  {{
                    translationKey !== 'exam'
                      ? ('liveEvents.setup.label.addNormalQuestion' | translate)
                      : ('content.exam.addNormalQuestion' | translate)
                  }}
                </button>
                @if (allowPollQuestions) {
                <button mat-menu-item (click)="addQuestion(true)">
                  {{ 'liveEvents.setup.label.addPollQuestion' | translate }}
                </button>
                }
                <button
                  data-cy="dropdownImportBtn"
                  mat-menu-item
                  (click)="importItem()"
                >
                  {{ 'liveEvents.setup.label.import' | translate }}
                </button>
              </mat-menu>
              }
            </div>
          </div>
        </div>

        <div class="questions-body question-body-style">
          <ng-scrollbar>
            <div @fade class="questions-body-content">
              <div class="questions-body-top-list">
                <ng-container
                  [ngTemplateOutlet]="listTemplate"
                  [ngTemplateOutletContext]="{
                    list: questions
                  }"
                >
                </ng-container>
              </div>
            </div>
          </ng-scrollbar>
        </div>

        <ng-template #listTemplate let-list="list">
          @if (!list || !list?.length) {
          <div class="wizard-wrapper" [class.hide-section]="!wizardImports">
            <div class="wizard-wrapper-title">
              {{
                'content.wizardActions.description.noContent'
                  | translate
                    : {
                        name: 'common.label.questions' | translate | lowercase
                      }
              }}
            </div>
            <div class="wizard-wrapper-description">
              {{ 'content.wizardActions.description.wantToCreate' | translate }}
            </div>
            <qa-add-content-wizard
              [wizardImports]="wizardImports"
            ></qa-add-content-wizard>
          </div>
          <div class="no-content" [class.hide-section]="wizardImports">
            <mat-icon>manage_search</mat-icon>
            <p>
              {{ 'common.list.noContent' | translate }}
              @if (translationKey !== 'exam') {
              {{ 'liveEvents.setup.questionInLiveevent' | translate }}. } @else
              { {{ 'exam.setup.questionInExam' | translate }}. }
            </p>
            @if (!list?.length) {
            <div class="btn-container">
              <qa-button
                [isRaisedButton]="true"
                (submitted)="addQuestion()"
                [label]="
                  translationKey !== 'exam'
                    ? 'liveEvents.setup.label.addNormalQuestion'
                    : 'common.button.createNew'
                "
                icon="add"
                [minWidth]="200"
                [showIconAtEnd]="true"
                data-cy="createNewQuestion"
              ></qa-button>
              @if (allowPollQuestions) {
              <qa-button
                [isRaisedButton]="true"
                (submitted)="addQuestion(true)"
                label="liveEvents.setup.label.addPollQuestion"
                icon="add"
                [minWidth]="200"
                [showIconAtEnd]="true"
              ></qa-button>
              }
              <qa-button
                [isRaisedButton]="true"
                (submitted)="importItem()"
                label="common.button.add"
                icon="file_upload"
                [minWidth]="200"
                [showIconAtEnd]="true"
                data-cy="importItem"
              ></qa-button>
            </div>
            }
            <div class="chat-gpt" (click)="openGPT()">
              <img src="assets/icons/chat-gpt.svg" alt="gpt" />
              <div>{{ 'chatgptImports.title' | translate }}</div>
              <mat-icon>chevron_right</mat-icon>
            </div>
          </div>
          } @if (list?.length) {
          <div class="list-wrapper">
            <mat-list
              [class.multi-selection]="selectedItemIds?.length > 0"
              (cdkDropListDropped)="afterItemDropped($event, list)"
              cdkDropList
              cdkDropListLockAxis="y"
            >
              <mat-list-item class="list-item-header">
                <mat-icon></mat-icon>
                <mat-checkbox
                  class="check-all"
                  [indeterminate]="someChecked"
                  [checked]="isAllChecked"
                  (change)="selectAll($event.checked)"
                  color="primary"
                >
                </mat-checkbox>
                <div class="question-position"></div>
                <div class="item-text">
                  {{ 'question.table.text' | translate }}
                </div>
              </mat-list-item>
              <div
                class="question-list-wrapper"
                [class.isSelected]="selectedItemIds?.length > 0"
                [class.hasTimeLimit]="!isLiveEvent && isScheduledExam"
                [style.height.px]="list.length * LIST_ITEM_HEIGHT"
              >
                <ng-scrollbar>
                  @for (item of list; track $index; let i = $index) {
                  <mat-list-item
                    (click)="onselectQuestion(item)"
                    class="question-list-items"
                    data-cy="row"
                    [cdkDragData]="item"
                    cdkDrag
                    matRipple
                    [ngClass]="{
                      'question-selected': i === selectedQuestionid,
                      'is-poll': item.is_poll_question,
                      selected: selectedItemIds?.includes(item.id)
                    }"
                  >
                    <mat-icon
                      cdkDragHandle
                      class="drag-indicator drag-icon-indicator"
                      >drag_indicator</mat-icon
                    >
                    <div *cdkDragPlaceholder class="drag-placeholder"></div>
                    <mat-checkbox
                      (change)="
                        $event.checked
                          ? selectedItemIds.push(item.id)
                          : selectedItemIds.splice(
                              selectedItemIds.indexOf(item.id),
                              1
                            )
                      "
                      (click)="$event.stopPropagation()"
                      [checked]="selectedItemIds.includes(item.id)"
                      color="primary"
                    >
                    </mat-checkbox>
                    <div class="item-position question-position">
                      {{ i + 1 }}
                    </div>
                    <div class="item-text question-text" data-cy="questionText">
                      @if (item.is_poll_question) {
                      <span class="question-type-short">
                        {{ 'question.label.surveyQuestionShort' | translate }}
                        ({{ questionTypeDisplayFn(item.type, true) }})
                      </span>
                      } @if (!item.is_poll_question) {
                      <span class="question-type-short">
                        <span
                          >{{
                            'question.label.quizQuestionShort' | translate
                          }}
                          ({{ questionTypeDisplayFn(item.type, true) }})</span
                        >
                      </span>
                      }
                      <span> {{ item.text }}</span>
                    </div>
                    <div class="item-actions question-action-button">
                      <div class="item-actions">
                        <qa-mat-menu-button
                          [menu]="itemActionMenu"
                          data-cy="moreIcon"
                        ></qa-mat-menu-button>
                        <mat-menu
                          class="content-menu"
                          #itemActionMenu="matMenu"
                        >
                          <button
                            (click)="exportItemAsJSON(item)"
                            mat-menu-item
                            type="button"
                          >
                            <mat-icon>code</mat-icon>
                            {{
                              'content.question.actionMenu.downloadJSON'
                                | translate
                            }}
                          </button>
                          <button
                            (click)="removeQuestion(item.id)"
                            mat-menu-item
                            type="button"
                            data-cy="delete"
                          >
                            <mat-icon>link_off</mat-icon>
                            {{
                              translationKey + '.label.removeButtonLabel'
                                | translate
                            }}
                          </button>
                          <button
                            (click)="deleteQuestion(item.id)"
                            mat-menu-item
                            type="button"
                            data-cy="deletePermanently"
                          >
                            <mat-icon>delete</mat-icon>
                            {{
                              translationKey + '.label.deleteButtonLabel'
                                | translate
                            }}
                          </button>
                        </mat-menu>
                      </div>
                      <div class="fold-in-button right-arrow-button">
                        @if (!foldedSidebar && i === selectedQuestionid) {
                        <button mat-icon-button (click)="foldSidebar($event)">
                          <mat-icon>chevron_right</mat-icon>
                        </button>
                        }
                      </div>
                    </div>
                  </mat-list-item>
                  }
                </ng-scrollbar>
              </div>
            </mat-list>
            @if (selectedItemIds?.length > 0) {
            <div @fade class="selection-header">
              <div class="header-contents">
                <button
                  (click)="selectedItemIds = []"
                  mat-icon-button
                  type="button"
                >
                  <mat-icon>clear</mat-icon>
                </button>
                <span
                  >{{ selectedItemIds?.length + ' ' }}
                  {{ getItemSelectedText(selectedItemIds?.length === 1) }}
                </span>
              </div>
              <div class="selection-header-actions">
                <qa-button
                  [isRaisedButton]="true"
                  [label]="
                    (isLiveEvent
                      ? 'liveEvents.label.removeButtonLabel'
                      : 'exam.label.removeButtonLabel'
                    ) | translate
                  "
                  (submitted)="deleteAllSelected()"
                ></qa-button>
              </div>
            </div>
            }
          </div>
          }
        </ng-template>
      </div>
    </qa-content-spinner>
  </div>
  <div class="edit-entiity">
    @if (!!selectedQuestion) {
    <button
      mat-icon-button
      class="mobile-back-button"
      (click)="
        selectedQuestion = undefined;
        foldedSidebar = true;
        selectedQuestionid = undefined
      "
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    } @if (selectedQuestion) {
    <qa-question-edit
      (closeSideMenu)="closeSideMenu($event)"
      (updatedQuestion)="updateQuestions()"
      [questionId]="selectedQuestion?.id"
      [isLiveEvent]="queryParams.liveEventId"
    ></qa-question-edit>
    }
  </div>
</div>
